import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from './reducers';
import 'babel-polyfill';
import App from './app';

const StoreInstance = createStore( rootReducer, composeWithDevTools(applyMiddleware( thunk )));

ReactDOM.render(
	<BrowserRouter>
		<Provider store={StoreInstance}>
			<Route component={App} />
		</Provider>
	</BrowserRouter>,
	document.getElementById('container')
);







// WEBPACK FOOTER //
// ./index.js